
const destinationsSelector = (destinations: any[]) => {
  return destinations;
};

export default destinationsSelector;
